import axios from "axios";
import { API_BASE_URL } from "./constants";

const instance = axios.create({
    baseURL: API_BASE_URL+"api",
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add token to every request
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    res => res,
    err => {
        if (err.response && err.response.status === 401) {
            // Remove invalid token and redirect to login
            localStorage.removeItem("token");
            delete instance.defaults.headers.common["Authorization"];
            // Uncomment if you want to redirect automatically
            // window.location.href = "/admin/login";
        }
        return Promise.reject(err);
    }
);

export default instance;
